import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from '../../RoomParty/getRoomParty.api';


interface RoomPartiesData {
    roomPartiesOverMaxOccupancy: RoomParty[]
}

export const GET_ROOM_PARTIES_QUERY = gql`
  query roomPartiesOverMaxOccupancy{
    roomPartiesOverMaxOccupancy{
      ${gqlRoomParty}
    }
  }
`;

export const getRoomPartiesOverMaxOccupancy = () => useQuery<RoomPartiesData>(
    GET_ROOM_PARTIES_QUERY,
    {
        
    }
);

export default getRoomPartiesOverMaxOccupancy;